import { Component, h } from '@stencil/core';
import store from '../../../../../global/store';
import { tracker } from '../../../../../global/tracker';

@Component({
  tag: 'ui-bank-search-intro-current-location',
  shadow: false,
})
export class UiBankSearchIntroCurrentLocation {
  onCurrentLocationClick() {
    if (!store.state.google) return;

    const currentLocationOnSuccess = (pos: GeolocationPosition) => {
      store.state.selectedPlaceName = `${(window as any).ui.services?.i18n?.translate('bankSearch').currentLocation || 'Aktueller Standort'}`;
      store.state.selectedPlaceLocation = new google.maps.LatLng(
        pos.coords.latitude,
        pos.coords.longitude
      );
    };
    const currentLocationError = (err) => {
      if (err.code === err.PERMISSION_DENIED) {
        store.state.errorMessage = `${(window as any).ui.services?.i18n?.translate('bankSearch').errorMessageBlockedGeolocation || 'Bitte aktivieren Sie die Geolokalisierung in Ihrem Browser, um diese Funktion zu verwenden.'}`;
        return;
      }
      store.state.errorMessage = `${(window as any).ui.services?.i18n?.translate('bankSearch').errorMessageGeolocationNotSupported || 'Ihr "Aktueller Standort" konnte nicht ermittelt werden. Bitte nutzen Sie die Suche und geben Sie eine PLZ, einen Ort oder einen Banknamen ein.'}`;
    };

    navigator.geolocation.getCurrentPosition(
      currentLocationOnSuccess,
      currentLocationError,
      {
        enableHighAccuracy: true,
        timeout: 60000,
        maximumAge: 0,
      }
    );

    tracker.trackInputLocationLink();
  }

  render() {
    return (
      <div>
        <sd-button
          variant="tertiary"
          onClick={this.onCurrentLocationClick.bind(this)}
        >
          <sd-icon
            library={(window as any).ui.cmsState?.iconLibrary}
            name="union-investment/system/gps"
          ></sd-icon>
          {(window as any).ui.services?.i18n?.translate('bankSearch')
            .currentLocation || 'Aktueller Standort'}
        </sd-button>
      </div>
    );
  }
}
